<bootstrap-popup
	[id]="id"
	[displaySubject]="displayState$" 
	[title]="displayRules? displayRules.title : ''"
	[windowCloseButton]="true"
	>
	<ng-container *ngIf="displayRules as display">
		<job-progress
			[jobExecutionId]="display.jobExecutionId"
			(jobCompleted)="onJobCompleted($event)"
			>
		</job-progress>
		<form *ngIf="display.manualClose"
			role="form" class="form-horizontal">
			<br />
			<div class="actions">
				<button
					type="button"
					class="btn btn-primary"
					[disabled]="!allowClose"
					(click)="onManualCloseRequested()"
					>
					Fermer
				</button>
			</div>
		</form>
	</ng-container>
</bootstrap-popup>